import React from 'react';
import { styled } from '../theming';
import { responsiveProp } from '../utils/responsiveProp';

import { Logo } from './Logo';
import { LogoSimplified } from './LogoSimplified';
import { ResponsiveLogoProps } from './types';

const ResponsiveLogoContainer = styled.div<ResponsiveLogoProps>(({ simplified }) =>
  responsiveProp(simplified, (simplified) => ({
    '> svg:nth-child(1)': {
      display: simplified ? 'none' : 'block',
    },
    '> svg:nth-child(2)': {
      display: simplified ? 'block' : 'none',
    },
  }))
);

export function LogoResponsive({ simplified = false }: Partial<ResponsiveLogoProps>) {
  return (
    <ResponsiveLogoContainer simplified={simplified}>
      <Logo />
      <LogoSimplified />
    </ResponsiveLogoContainer>
  );
}
